import React from 'react';
import { useTranslation } from 'react-i18next';

import { useListingContext } from '@/context/listing';
import { calculateFilterColor } from '@/utils/Common/ListingUtils';
import _isEmpty from 'lodash/isEmpty';

const SelectedFiltersMenu = () => {
  const { t } = useTranslation();
  const [{ filtersData }, { pushQuery, clearFilters }] = useListingContext();

  const allSelectedFilters = filtersData.facets.reduce((accFacet, facet, i) => {
    if (!_isEmpty(facet.values[i])) {
      facet.values[i].nameLabel = !_isEmpty(facet.name) ? facet.name : '';
    }
    facet.values
      .map(value => ({
        ...value,
        name:
          facet.code === 'percentageDiscountValue'
            ? t('listing:filter.option.discount.range', {
                range: value.name,
              })
            : value.name,
      }))
      .reduce(
        (accFilter, filter) =>
          filter.selected ? accFacet.push(filter) : accFacet,
        0,
      );
    return accFacet;
  }, []);

  const filterItems = allSelectedFilters.map(filter => {
    const { name } = calculateFilterColor(filter.name);
    return (
      <button
        type='button'
        className='del-button del-plp-filters__selected-filter-item js-filter-remove'
        key={filter.code}
        data-filter-label={filter.nameLabel}
        data-filter-detail={filter.code}
        onClick={() => pushQuery(filter.query)}
      >
        <span className='del-plp-filters__selected-filter-text'>
          <i className='del-icon icon-menu-close del-plp-filters__selected-filter-close-icon' />
          {name}
        </span>
      </button>
    );
  });

  return (
    <div className='del-plp-filters__selected-filters-menu'>
      {filterItems}{' '}
      <button
        type='button'
        className='del-button del-plp-filters__selected-filter-clear-all js-filter-removeall'
        onClick={clearFilters}
      >
        {t('listing:listing.clear.filters.cta.label')}
      </button>
    </div>
  );
};

export default SelectedFiltersMenu;
